// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2hLVm","noInteraction":"EventWrapper_noInteraction__TUe2e","pointerPassthrough":"EventWrapper_pointerPassthrough__3bL7d"};